/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-console */
import {
  Paper,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import LENDINGS_TABLE_HEADERS from '@pages/lending/constants/LendingTableHeader.constants';
import { LendingServiceResponse } from '@pages/lending/types';
import { t } from 'i18next';
import { useState } from 'react';
import { Table } from 'reactstrap';
import EmptySate from './EmptySate';
import TableRowComponent from './TableRow';

interface LendingTableProps {
  data: LendingServiceResponse[];
  loading: boolean;
}

const LendingTable = ({ data, loading }: LendingTableProps) => {
  const [showInvoice, setShowInvoice] = useState<string | undefined>(undefined);
  const [showDetail, setShowDetail] = useState<string | undefined>(undefined);
  const [payLending, setPayLending] = useState<string | undefined>(undefined);

  return (
    <TableContainer component={Paper} className="px-5">
      <Table className="mui-table w-full border-separate border-spacing-y-3">
        <TableHead className="!hidden">
          <TableRow>
            {LENDINGS_TABLE_HEADERS.map((header) => (
              <TableCell
                className={!data?.length ? '!text-[#C0C0C0]' : ''}
                align="center"
                key={header}
              >
                {t(header)}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        {!loading && !data?.length ? <EmptySate /> : null}
        {data?.length ? (
          <TableBody>
            {data.map((row) => (
              <TableRowComponent
                key={row.id}
                row={row}
                showInvoice={setShowInvoice}
                showDetail={setShowDetail}
                paylending={setPayLending}
              />
            ))}
          </TableBody>
        ) : null}
      </Table>
    </TableContainer>
  );
};

export default LendingTable;
